(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-profile/assets/javascripts/views/start.js') >= 0) return;  svs.modules.push('/modules/player-profile/assets/javascripts/views/start.js');

'use strict';

svs.player_profile.views.Start = Marionette.View.extend({
  template(data) {
    return svs.player_profile.templates.start(data);
  },
  regions: {
    navigationRegion: '.js-navigation-region',
    containerRegion: '.js-container-region'
  },
  behaviors: {
    ServerSideRendering: {
      behaviorClass: svs.app.ServerSideHelper.ServerSideRendering,
      regionSetup() {
        const page = this.getOption('page');
        const view = this.getContainerView(page);
        return {
          navigationRegion: {
            view: svs.player_profile.views.Navigation,
            options: {
              page
            }
          },
          containerRegion: {
            view,
            options: this.getContainerViewOptions(page)
          }
        };
      }
    }
  },
  initialize() {
    this.listenTo(svs.player_profile.radio, 'navigation', this.onNavigation, this);
  },
  onNavigation(target) {
    const View = this.getContainerView(target);
    this.getRegion('containerRegion').show(new View(this.getContainerViewOptions(target)));
  },
  getContainerView(page) {
    switch (page) {
      case 'kyc':
        return svs.player_profile.views.Kyc;
      default:
        return svs.player_profile.views.Profile;
    }
  },
  getContainerViewOptions(page) {
    switch (page) {
      case 'kyc':
        return {
          showSummary: true
        };
      default:
        return {
          urlList: this.getOption('urlList')
        };
    }
  }
});

 })(window);